import React, { Component } from 'react';
import './index.scss';
import IM from '@/component/im';

class Footer extends Component<any, any> {
    public render() {
        return (
            <div className="chj-footer">
                <div className="chj-footer-inner">
                    <div className="chj-footer-contract">
                        <a
                            href="/autoinfo/agreement.html?name=vehicle-maintenance"
                            target="_blank">
                            使用协议
                        </a>
                        <a
                            href="/autoinfo/agreement.html?name=register"
                            target="_blank">
                            注册协议
                        </a>
                        <a
                            href="/autoinfo/agreement.html?name=privacy"
                            target="_blank">
                            隐私政策
                        </a>
                    </div>
                    <div className="chj-footer-bottom">
                        <div className="chj-footer-bottom-link">
                            <a href="#im" onClick={this.callIM}>
                                在线客服
                            </a>
                            <a href="tel:4006860900">客服电话 400-686-0900</a>
                            <a href="mailto:press@lixiang.com">
                                媒体咨询: <span>press@lixiang.com</span>
                            </a>
                        </div>
                        <div className="chj-footer-bottom-copyright">
                            <span>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="http://beian.miit.gov.cn/">
                                    ©{new Date().getFullYear()}{' '}
                                    京ICP备19003172号
                                </a>
                            </span>
                            <span>
                                <i className="emblem" />
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302001865">
                                    京公网安备11011302001865号
                                </a>
                            </span>
                            <span>北京车励行信息技术有限公司@版权所有</span>
                            <span>
                                增值电信业务经营许可证：编号京B2-20191092/编号B2-20196074
                            </span>
                            <span>
                                北京市顺义区高丽营镇恒兴路4号院1幢105室(科技创新功能区)
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private callIM = () => {
        IM.goIM('autoOpen-footer', '6');
    };
}

export default Footer;
